export enum FontFamily {
  body = "'lato', Arial, Helvetica, sans-serif",
  code = "'Source Code Pro', 'Courier New', Courier, monospace",
}
